import { SVGProps } from 'react'

const Error404Svg = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="11.13 29.94 580.94 208.51"
        {...props}
    >
        <path
            d="M198.043 192.664h-32.832V235h-45.504v-42.336H11.131v-31.392L106.171 33.4h48.96L67.003 154.648h54.144V116.92h44.064v37.728h32.832v38.016Zm100.355 45.792c-16.704 0-31.584-4.128-44.64-12.384-13.056-8.256-23.328-20.16-30.816-35.712-7.296-15.744-10.944-34.464-10.944-56.16 0-21.696 3.648-40.32 10.944-55.872 7.488-15.744 17.76-27.744 30.816-36 13.056-8.256 27.936-12.384 44.64-12.384s31.584 4.128 44.64 12.384c13.056 8.256 23.232 20.256 30.528 36 7.488 15.552 11.232 34.176 11.232 55.872 0 21.696-3.744 40.416-11.232 56.16-7.296 15.552-17.472 27.456-30.528 35.712-13.056 8.256-27.936 12.384-44.64 12.384Zm0-39.456c12.288 0 21.888-5.28 28.8-15.84 7.104-10.56 10.656-26.88 10.656-48.96 0-22.08-3.552-38.4-10.656-48.96-6.912-10.56-16.512-15.84-28.8-15.84-12.096 0-21.696 5.28-28.8 15.84-6.912 10.56-10.368 26.88-10.368 48.96 0 22.08 3.456 38.4 10.368 48.96 7.104 10.56 16.704 15.84 28.8 15.84Zm293.676-6.336h-32.832V235h-45.504v-42.336H405.162v-31.392L500.202 33.4h48.96l-88.128 121.248h54.144V116.92h44.064v37.728h32.832v38.016Z"
            fill="#FF0101"
        />
    </svg>
)

export default Error404Svg
